import React from 'react';

import { Grid, MenuItem } from '@mui/material';

import { GridFilter, ContainerFilter, Div, TextFieldStyled, CleanButton, FilterButton } from './styles';

const months = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' }
];

const statusOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'approved', label: 'Aprovados' },
    { value: 'pending', label: 'Pendentes' },
    { value: 'not_visited', label: 'Não visitada' }
];

const visitPeriodOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'half', label: 'Meia visita' },
    { value: 'full', label: 'Visita inteira' }
];

const DashboardFilters = ({ years, cycles, consultants, tempFilters, onFilterChange, onApply, onClear }) => {
    return (
        <GridFilter item xs={12} marginBottom="2rem">
            <ContainerFilter>
                <Grid item>
                    <p>Ano</p>
                    <Div width="250px">
                        <TextFieldStyled
                            fullWidth
                            size="small"
                            select
                            value={tempFilters.year}
                            onChange={(e) => onFilterChange('year', e.target.value)}
                        >
                            {years.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </TextFieldStyled>
                    </Div>
                </Grid>
                <Grid item>
                    <p>Ciclo</p>
                    <Div width="250px">
                        <TextFieldStyled
                            fullWidth
                            size="small"
                            select
                            value={tempFilters.cycleId || ''}
                            onChange={(e) => onFilterChange('cycleId', e.target.value)}
                        >
                            {cycles?.map((cycle) => (
                                <MenuItem key={cycle.id} value={cycle.id}>
                                    {cycle.label}
                                </MenuItem>
                            ))}
                        </TextFieldStyled>
                    </Div>
                </Grid>
                <Grid item>
                    <p>Consultor</p>
                    <Div width="250px">
                        <TextFieldStyled
                            fullWidth
                            size="small"
                            select
                            value={tempFilters.consultantId ?? ''}
                            onChange={(e) => onFilterChange('consultantId', e.target.value || null)}
                            SelectProps={{ displayEmpty: true }}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {consultants?.map((c) => (
                                <MenuItem key={c.id} value={c.id}>
                                    {c.name}
                                </MenuItem>
                            ))}
                        </TextFieldStyled>
                    </Div>
                </Grid>
                <Grid item>
                    <p>Status</p>
                    <Div width="250px">
                        <TextFieldStyled
                            fullWidth
                            size="small"
                            select
                            value={tempFilters.status}
                            onChange={(e) => onFilterChange('status', e.target.value)}
                        >
                            {statusOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextFieldStyled>
                    </Div>
                </Grid>
                <Grid item>
                    <p>Período da visita</p>
                    <Div width="250px">
                        <TextFieldStyled
                            fullWidth
                            size="small"
                            select
                            value={tempFilters.status === 'not_visited' ? 'all' : tempFilters.visitPeriod}
                            onChange={(e) => onFilterChange('visitPeriod', e.target.value)}
                            disabled={tempFilters.status === 'not_visited'}
                        >
                            {visitPeriodOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextFieldStyled>
                    </Div>
                </Grid>
            </ContainerFilter>
            <Grid item padding={2}>
                <CleanButton onClick={onClear}>Limpar</CleanButton>
            </Grid>
            <Grid item padding={2}>
                <FilterButton variant="contained" color="primary" onClick={onApply}>
                    Filtrar
                </FilterButton>
            </Grid>
        </GridFilter>
    );
};

export default DashboardFilters;
